import React, { Component } from 'react';
import _validator from 'modules/validator';
import Button from 'components/controls/Button';

import _BankAdminServices from '../../modules/BankAdminServices';
import _BiometricAdminServices from '../../modules/BiometricAdminServices';
import { Spin } from 'antd';
import _notification from 'modules/notification';
import DropdownList from "../../components/controls/DropdownList";

import MyInput from '../../components/controls/MyInput';

import _utils from '../../modules/Utils';
import _authService from '../../modules/AuthService';
import { CANDIDATE_REMARK, Is_Aadharverification_PostExam } from '../../constants/constants';

// let CANDIDATE_REMARK = [
//     "Fingerprint matched successfully",
//     "Fingerprint did not match",
//     "Scanner unable to read fingerprint – retry limit reached – verified using documents",
//     "Candidate has finger/thumb injury – verified using documents",
//     "Candidate has mehendi/ink/stain – verified using documents",
//     "Candidate refused fingerprint scan – verified using documents",
//     "Fingerprint scanner hardware issue – verified using documents",
//     "Candidate has worn-out fingerprints – verified using documents",
//     "Other (specify manually)"
// ];

class InitializedNSDL extends Component {
    constructor(props) {
        super(props);
        this.textInput = React.createRef()
        this.state = {
            data: null,
            roleNumber: null,
            roleNumberState: "",
            roleNumberError: "",
            url: "", // store the URL to redirect to
            clinetId: "",
            name: "",
            should_name_match: false,
            country: "",
            state: "",
            pin_code: "",
            aaadhar_last_four_digits: "",
            year_of_birth: "",
            gender: "",
            client_id: null,
            status_code: null,
            message_code: null,

            selectedOption: null,
            remark: "",
            remarkError: "",
            error: "",
            showReport: false,
            loading: false,
            systemFullName:null,
            InitializedNSDLResponse:false,

        };
    }

    componentDidMount() {
        // Any initial API calls or setup
    }

    componentWillUnmount() {
        _authService.clearSessionHist();
    }

    InitializeNSDL = async (ev) => {
        try {
            ev.preventDefault();

            if (this.state.roleNumber) {
                this.setState({ loading: true }, async () => {
                    try {
                        let response = await _BiometricAdminServices.InitializeNSDL(this.state.roleNumber);
                       // debugger
                        if (response.data.success) {
                            const result = response.data.data; // Extract nested data
                          //  debugger
                            this.setState({
                                data: result,
                                url: result.url, // Corrected: get nested URL
                                InitializedNSDLResponse:response.data.success,
                                // url: "swapnil" ,// Corrected: get nested URL
                                clinetId: result.client_id,
                                loading: false,
                                roleNumberState: "", // Clear any previous errors
                                systemFullName:response.data.system_full_Name
                            });
                        } else {
                            this.setState({ loading: false });
                            _notification.showMessage('error', response.data.message);
                        }

                    } catch (e) {
                        this.setState({ loading: false });
                        console.log('Error: ', e);
                        _notification.showMessage('error', "Enter Valid RoleNumber");
                    }
                });
            } else {
                this.setState({ roleNumberState: "error", roleNumberError: "Role Number is required and cannot be empty." });
            }
        } catch (e) {
            console.error(e);
        }
    }


    onTextChange = ({ target: { name, value } }) => {
        this.setState({ [name]: value });
    }

    clearData = async () => {
        this.setState({ roleNumber: "", data: null, url: "", roleNumberError: "" });
    }

    preventCopyPaste = (e) => {
        e.preventDefault();
    }

    // Handle the proceed button click to open the URL
    handleProceed = () => {
        if (this.state.InitializedNSDLResponse && this.state.url && this.state.roleNumber) {
            window.open(this.state.url, '_blank'); // Open the URL in a new tab
        }
    }

    // getCandidateReport = async (ev) => {
    //     try {
    //         ev.preventDefault();

    //         this.setState({ loading: true }, async () => {
    //             try {
    //                 const clientId = "esign_pZzCZIjYtuGODHrrtbXnn"; // hardcoded client ID
    //                 let response = await _BiometricAdminServices.GetReportByClientId(clientId);

    //                 // let response = await _BiometricAdminServices.GetReportByClientId(this.state.clientId);
    //                 debugger;

    //                 if (response.data.success) {
    //                     const reportData = response.data.data.reports.name_match;
    //                     const certificate = reportData.certificate_details;

    //                     this.setState({
    //                         name: reportData.name,
    //                         should_name_match: reportData.should_name_match,
    //                         country: certificate.country,
    //                         state: certificate.state,
    //                         pin_code: certificate.pin_code,
    //                         aaadhar_last_four_digits: certificate.aaadhar_last_four_digits,
    //                         year_of_birth: certificate.year_of_birth,
    //                         gender: certificate.gender,
    //                         client_id: response.data.data.client_id,
    //                         status_code: response.data.status_code,
    //                         message_code: response.data.message_code,
    //                         showReport: true,
    //                         loading: false,
    //                     });
    //                 } else {
    //                     this.setState({ loading: false });
    //                     _notification.showMessage('error', response.data.message);
    //                 }

    //             } catch (error) {
    //                 this.setState({ loading: false });
    //                 console.error("Error fetching report: ", error);
    //                 _notification.showMessage('error', "Something went wrong");
    //             }
    //         });
    //     } catch (err) {
    //         console.error(err);
    //     }
    // }



    getCandidateReport = async (ev) => {
        try {
            ev.preventDefault();

            // Check if the client ID is empty or invalid
            //  const clientId = "esign_pZzCZIjYtuGODHrrtbXn"; // hardcoded client ID for testing
            let clientId = this.state.clinetId;

            if (!clientId) {
                // If the ID is invalid or empty, show default data (nulls or placeholders)
                this.setState({
                    client_id: 'Not Available',
                    status_code: 'Not Available',
                    message_code: 'Not Available',
                    name: 'Not Available',
                    should_name_match: 'Not Available',
                    country: 'Not Available',
                    state: 'Not Available',
                    pin_code: 'Not Available',
                    aaadhar_last_four_digits: 'Not Available',
                    year_of_birth: 'Not Available',
                    gender: 'Not Available',
                    showReport: true,
                });
            } else {
                this.setState({ loading: true }, async () => {
                    try {
                        let response = await _BiometricAdminServices.GetReportByClientId(this.state.clinetId);

                        if (response.data.success) {
                            const reportData = response.data.data.reports.name_match;
                            const certificate = reportData.certificate_details;

                            this.setState({
                                name: reportData.name,
                                should_name_match: reportData.should_name_match,
                                country: certificate.country,
                                state: certificate.state,
                                pin_code: certificate.pin_code,
                                aaadhar_last_four_digits: certificate.aaadhar_last_four_digits,
                                year_of_birth: certificate.year_of_birth,
                                gender: certificate.gender,
                                client_id: response.data.data.client_id,
                                status_code: response.data.status_code,
                                message_code: response.data.message_code,
                                showReport: true,
                                loading: false,
                            });
                        } else {
                            this.setState({ loading: false });
                            _notification.showMessage('error', response.data.message);
                        }
                    } catch (error) {
                        this.setState({ loading: false });
                        console.error("Error fetching report: ", error);
                        _notification.showMessage('error', "Error fetching report data");
                    }
                });
            }
        } catch (err) {
            console.error(err);
        }
    };


    clearCandidateReport = () => {
        this.setState({
            client_id: "",
            status_code: null,
            message_code: "",

            name: "",
            should_name_match: false,
            country: "",
            state: "",
            pin_code: "",
            aaadhar_last_four_digits: "",
            year_of_birth: "",
            gender: "",

            remark: "",
            selectedOption:null,
            remarkError: "",
            InitializedNSDLResponse:false,
            url:"",
            roleNumber:"",
            loading: false,
            showReport: false,

        });
    };



    handleSubmit = async () => {
        const { client_id, status_code, message_code, remark, roleNumber, selectedOption } = this.state;

        if (selectedOption === "Other (specify manually)" && remark.trim() === '') {
            this.setState({ error: 'Remark is required.' });
            return;
        }

        if (!selectedOption) {
            this.setState({ remarkError: 'Please select a remark.' });
            return;
        }

        // Use remark if "Other", else use selectedOption
        const finalRemark = selectedOption === "Other (specify manually)" ? remark.trim() : selectedOption;

        const payload = {
            Esign_ClientId: client_id || null,
            Esign_StatusCode: status_code || null,
            Esign_Message_Code: message_code || null,
            Esign_Remarks: finalRemark,
            roleNumber: parseInt(roleNumber) || null,
            Is_Aadharverification_PostExam: Is_Aadharverification_PostExam,
        };

        console.log('Payload:', payload);

        try {
            let response = await _BiometricAdminServices.updateStudentBiometricData(payload);
            console.log('API response:', response);

            if (response?.data?.IsSuccess) {
                _notification.showMessage('success', 'Candidate Remark updated successfully!');

                this.clearCandidateReport();
                
            } else {
                _notification.showMessage('error', `Failed to update Candidate Remark: ${response?.data?.Message || 'Unexpected response.'}`);
            }
        } catch (error) {
            console.error('Update failed:', error.response?.data || error.message || error);
            _notification.showMessage('error', 'Failed to update Candidate Remark.');
        }
    };

    handleDropdownChange = (e) => {
        const selected = e.target.value;
        this.setState({
            selectedOption: selected,
            remark: selected === "Other (specify manually)" ? '' : selected,  // Set remark directly unless it's Other
            remarkError: '',
            error: ''
        });
    };

    // handleChange = (e) => {
    //     const { name, value } = e.target;
    //     this.setState({ [name]: value }); // ✅ This updates 'remark'
    // };

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({
            [name]: value,
            // Clear error when remark is being typed
            ...(name === "remark" && { error: '' })
        });
    };

    render() {

        let remarkOptions = CANDIDATE_REMARK.map(item => ({
            Id: item,
            Name: item,
        }));

        const {
            client_id, status_code, message_code, roleNumber, remarkError, selectedOption,
            name, should_name_match, country, state, remark,
            pin_code, aaadhar_last_four_digits, year_of_birth,
            gender, loading, showReport,systemFullName,
        } = this.state;

        return (
            <>
                <div>
                    <div className=" mt-3 wrap-back-admin whiteBg gl-bxbr p-4 my-4  max1000 mx-auto  d-flex align-items-center justify-content-center flex-column">
                        <h4 className="heading4 mb-3">Candidate Biometric Verification Portal</h4>
                        <div className="mt-2 topRow d-flex align-items-start w-100 justify-content-center">
                            <div className="backadmin-search mr-4">
                                <MyInput
                                    wrapClass="w-100 mb-0 hideLabel"
                                    key="roleNumber"
                                    type="number"
                                    value={this.state.roleNumber}
                                    name="roleNumber"
                                    onChange={this.onTextChange}
                                    placeholder="Candidate Role Number*"
                                    isRequired={true}
                                    errorState={this.state.roleNumberState}
                                    errorMessage={this.state.roleNumberError}
                                />
                            </div>
                            <Button
                                onClick={this.InitializeNSDL}
                                className="button-global button-primary autoHeight small mr-4"
                                style={{ height: '30px', fontSize: '16px' }}
                                value="Initialize"
                            ></Button>

                            <Button
                                onClick={this.clearData}
                                className="button-global button-secondary  autoHeight small"
                                style={{ height: '30px', fontSize: '16px' }}
                                value="Clear"
                            ></Button>
                        </div>
                    </div>

                    {this.state.loading && <Spin size="large" />}

                    {/* Render Proceed button if URL is available */}

                    {this.state.InitializedNSDLResponse && this.state.url && (
                        <div className="proceed-button-container" style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                            <Button
                                onClick={this.handleProceed}
                                className="button-global button-primary "
                                style={{
                                    height: '50%',
                                    width: '50%',
                                    backgroundColor: '#007bff', // Bootstrap blue or any shade of blue
                                    borderColor: '#007bff',
                                    color: 'white',
                                    padding: '0 20px',
                                    fontWeight: 'bold',
                                }}
                                value="Proceed"
                            />
                        </div>
                    )}
                </div>

                <div>
                {this.state.InitializedNSDLResponse &&  (

                    <div className="wrap-back-admin whiteBg gl-bxbr p-4 mb-4 mt-100  max1000 mx-auto d-flex align-items-center justify-content-center flex-column">
                        <h4 className="heading4 mb-3">Candidate Report</h4>

                        <div className="mt-2 topRow d-flex align-items-start w-100 justify-content-center">
                            {/* Get Candidate Report Button */}
                            <button
                                onClick={this.getCandidateReport}
                                className="button-global button-primary mr25 width-35"
                                style={{ height: '50px', fontSize: '16px' }}
                            >
                                Get Candidate Report
                            </button>

                            {/* Clear Candidate Report Button */}
                            <button
                                onClick={this.clearCandidateReport}
                                className="button-global button-secondary width-35"
                                style={{ height: '50px', fontSize: '16px' }}
                            >
                                Clear Candidate Report
                            </button>
                        </div>
                    </div>
                )}

                    {/* {showReport && (
                        <div style={{ marginTop: '20px' }} className="wrap-back-admin whiteBg gl-bxbr p-4 my-4  max1000 mx-auto  d-flex align-items-center justify-content-center flex-column">
                            <h3 className="heading4 mb-3">Candidate Report</h3>
                            <table border="1" cellPadding="10">
                                <tbody>
                                    <tr><td><strong>Client ID</strong></td><td>{client_id}</td></tr>
                                    <tr><td><strong>Status Code</strong></td><td>{status_code}</td></tr>
                                    <tr><td><strong>Message Code</strong></td><td>{message_code}</td></tr>
                                    <tr><td><strong>Name</strong></td><td>{name}</td></tr>
                                    <tr><td><strong>Should Name Match</strong></td><td>{should_name_match ? "Yes" : "No"}</td></tr>
                                    <tr><td><strong>Country</strong></td><td>{country}</td></tr>
                                    <tr><td><strong>State</strong></td><td>{state}</td></tr>
                                    <tr><td><strong>Pin Code</strong></td><td>{pin_code}</td></tr>
                                    <tr><td><strong>Aadhaar Last 4 Digits</strong></td><td>{aaadhar_last_four_digits}</td></tr>
                                    <tr><td><strong>Year of Birth</strong></td><td>{year_of_birth}</td></tr>
                                    <tr><td><strong>Gender</strong></td><td>{gender}</td></tr>
                                </tbody>
                            </table>
                        </div>
                    )} */}


                    {showReport && (
                        <>
                            <div
                                style={{ marginTop: '20px' }}
                                className="wrap-back-admin whiteBg gl-bxbr p-4 my-4 max1000 mx-auto d-flex align-items-center justify-content-center flex-column"
                            >
                                <h3 className="heading4 mb-3">Candidate Report ({systemFullName})</h3>

                                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                    {/* First Table */}
                                    <table border="1" cellPadding="10" style={{ width: '48%' }}>
                                        <tbody>
                                            <tr><td><strong>Client ID</strong></td><td>{client_id}</td></tr>
                                            <tr><td><strong>Status Code</strong></td><td>{status_code}</td></tr>
                                            <tr><td><strong>Message Code</strong></td><td>{message_code}</td></tr>
                                            <tr><td><strong>Name</strong></td><td>{name}</td></tr>
                                            <tr><td><strong>Should Name Match</strong></td><td>{should_name_match == true ? "Yes" : "No"}</td></tr>
                                        </tbody>
                                    </table>

                                    {/* Second Table */}
                                    <table border="1" cellPadding="10" style={{ width: '48%' }}>
                                        <tbody>
                                            <tr><td><strong>Country</strong></td><td>{country}</td></tr>
                                            <tr><td><strong>State</strong></td><td>{state}</td></tr>
                                            <tr><td><strong>Pin Code</strong></td><td>{pin_code}</td></tr>
                                            <tr><td><strong>Aadhaar Last 4 Digits</strong></td><td>{aaadhar_last_four_digits}</td></tr>
                                            <tr><td><strong>Year of Birth</strong></td><td>{year_of_birth}</td></tr>
                                            <tr><td><strong>Gender</strong></td><td>{gender}</td></tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div className="wrap-back-admin whiteBg gl-bxbr p-4 mb-4 mt-100 max1000 mx-auto d-flex align-items-center justify-content-center flex-column">
                                <h4 className="heading4 mb-3">Update Candidate Remark</h4>

                                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '20px', flexWrap: 'wrap' }}>
                                    <div className="w-100">
                                        <DropdownList
                                            value={selectedOption}
                                            name="remarkDropdown"
                                            onChange={this.handleDropdownChange}
                                            placeholder="Select Remark (टीप निवडा)"
                                            heading={
                                                <div className="displayInGrid">
                                                    <div>Remark(टीप)</div>
                                                </div>
                                            }
                                            className="w-100"
                                            wrapClass="wrap"
                                            isRequired={true}
                                            options={remarkOptions}
                                            errorState={remarkError}
                                            errorMessage={remarkError}
                                        />
                                    </div>

                                    {selectedOption === "Other (specify manually)" && (
                                        <>
                                            <textarea
                                                name="remark"
                                                rows={4}
                                                placeholder="Enter custom remark..."
                                                value={remark}
                                                onChange={this.handleChange}
                                                style={{
                                                    width: "100%",
                                                    // margin: "20px 0",
                                                    marginBottom: this.state.error ? "4px" : "20px",
                                                    borderColor: this.state.error ? "red" : "#ccc",
                                                    borderWidth: "1px",
                                                    borderStyle: "solid"
                                                }}
                                            />
                                            {this.state.error && (
                                                <div style={{ color: 'red' }}>{this.state.error}</div>
                                            )}
                                        </>
                                    )}

                                    <div>
                                        <button
                                            onClick={this.handleSubmit}
                                            className="button-global button-secondary w-25"
                                            style={{ height: '50px', marginLeft: "660px", fontSize: '16px', whiteSpace: 'nowrap' }}
                                        >
                                            Update
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}


                </div>
            </>
        );
    };
}

export default InitializedNSDL;
